import React, { Component } from 'react';
import { ICourseList } from '../../models/pages/coursePage';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import moment from 'moment';
import { SecureImage } from '../../components/core/secureImage';
import ProgressCircle from '../../components/progress-circle/progress-circle';
import { UserType } from '../../models/pages/login.d';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../models/action/core';
import * as ActionsCoursePage from '../../store/actions/coursePage';
import * as Actions from '../../store/actions/userHome';
import Tooltip from '../../components/tooltip/main';

let _common: Common;

const _logger = Log.create('PastSessionList');

const T = Translator.create();

const defaultCourse = `${process.env.PUBLIC_URL}/images/course/course.jpg`;
export class CPastSessionsList extends Component<ICourseList, any> {

    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            termCourses: this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ? Object.keys(this.groupBy(this.findPastTerms(), 'termId')).map((key) => this.groupBy(this.findPastTerms(), 'termId')[key]) : [],
            today: moment().format('yyyy-MM-DDTHH:mm:ss'),
            isTeacher: this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin),
            isMouseOver: false,
            filters: {
                termId: 0,
                programId: 0,
                status: -1,
                sourceCourseId: '',
                courseId: ''
            },
            elementsCount: 5,
            prevCourseId: '',
            showMore: false
        }
        this.afterCourseStar = this.afterCourseStar.bind(this);
        this.afterGetUserMyCourses = this.afterGetUserMyCourses.bind(this);
    }

    findPastTerms() {
        const isTeacher = this.props.userType !== UserType.Student
        const nowDate = moment().format('yyyy-MM-DDTHH:mm:ss');
        if (this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0) {
            const terms = this.props.userHomeMyCourses.filter(item => {
                const isDateRangeValid = isTeacher ? item.endDate && item.startDate && (item.endDate.toString() <= nowDate && item.startDate.toString() <= nowDate) : item.courseEndDate && item.courseStartDate && (item.courseEndDate.toString() <= nowDate && item.courseStartDate.toString() <= nowDate);
                return isDateRangeValid ?? item.termId !== null;
            });
            return terms;
        }
    }

    groupBy = (array: any, key: any) => {
        // Return the end result
        return array.reduce((result: any, currentValue: any) => {
            // If an array already present for key, push it to the array. Else create an array and push the object
            (result[currentValue[key]] = result[currentValue[key]] || []).push(
                currentValue
            );
            // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
            // var sortedList = [...result].sort(function(a,b) {
            //     return a.age_in_years - b.age_in_years ;
            // });
            // _logger.data('groupBy result', result);
            return result;
        }, {}); // empty object is the initial value for result object
    };

    public onShowMoreBtnClick = async (length: number) => {
        const value = this.state.elementsCount + 5 > length ? length : this.state.elementsCount + 5;
        this.setState({ elementsCount: value });
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.userHomeMyCourses &&
            this.props.userHomeMyCourses &&
            prevProps.userHomeMyCourses !== this.props.userHomeMyCourses) {

            let courseList = this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ?
                Object.keys(this.groupBy(this.findPastTerms(), 'termId')).map((key) => this.groupBy(this.findPastTerms(), 'termId')[key])
                : [];

            let sortedList = courseList;

            this.setState({
                termCourses: sortedList
            })
        }
    }

    public navigateUrl(classId?: string | null, activityId?: string | null) {
        const url = 'course?classId=' + classId + '&activityId=' + activityId + '&type=1';
        this.props.history.push(url);
    }

    // public navigateMessages() {
    //     const url = 'Message/Index';
    //     this.props.history.push(url);
    // }

    courseStar(courseId: any) {
        this.setState({ termCourses: [] })

        this.props.dispatch(ActionsCoursePage.setTriggerCourseStar(courseId, 'setTriggerCourseStar', 'set', this.afterCourseStar));

    }

    afterCourseStar = () => {
        this.props.dispatch(Actions.getUserHomeMyCourses(this.state.isTeacher, 'getUserHomeMyCourses', 'get', '', this.props.searchfilters ? this.props.searchfilters : this.state.filters, this.afterGetUserMyCourses));
    }

    afterGetUserMyCourses = () => {
        this.setState({
            termCourses: this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ?
                Object.keys(this.groupBy(this.findPastTerms(), 'termId')).map((key) => this.groupBy(this.findPastTerms(), 'termId')[key]) :
                [],
        });
    }

    public expandClicked = async (courseId: string) => {
        this.setState({ elementsCount: 5 });
            if (this.state.prevCourseId === '') {
                    this.setState({ prevCourseId: courseId });
            }
            else {
                if (this.state.prevCourseId === courseId) {

                    this.setState({ prevCourseId: '' });
                } else {

                    this.setState({ prevCourseId: courseId });
                }
            }
    }

    renderCourseInfo = (course: any) => {
        return (
            <div className="d-flex flex-column my_courses_name">
                <div className="alms-h6 d-flex course_term_flex" style={{ whiteSpace: 'pre-line' }}>
                    <div>
                        {
                            <div className="mobile-mt1">
                                <div>
                                    <span className='mt-1'>
                                        {course.programName && course.programName.length > 59 ?
                                            <> {this.state.showMore ? course.programName : `${course.programName.substring(0, 59)}...`} <button onClick={() => this.setState((prevState: any) => ({ showMore: !prevState.showMore }))} className={this.state.showMore ? "float-right ml-3" : "float-right show_more_text"} style={{ fontSize: "12px", margin: "0px 0px 0px 10px", color: this.state.showMore ? "#ff0000" : "#39B27B", border:'none', background:'none' }}>{T.t(this.state.showMore ? 'r_gen_show_less' : 'r_gen_show_more')}</button> </>
                                            : course.programName}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                    <div>
                        {course.activeStatus === 0 ?
                            <span className="archived_tag">{T.t('r_menu_course_archived2')}</span> : ''}
                    </div>
                    <div className="mobile-activity-edit">
                        {course.termName ? <span className="term_tag">{course.termName}</span> : <span className="term_tag">{T.t('r_gen_non_term_courses')}</span>}
                    </div>
                </div>
                <span className="alms-h5" onClick={this.navigateUrl.bind(this, course.classId, course.courseId)} style={{ cursor: 'pointer', marginBottom: 2.5 }}>{(course.name) ? course.name : ''}</span>
            </div>
        )
    }

    renderCourseOptions = (course: any) => {
        return (
            <div className="col-md-4 course_options mt-1">
                <a  style={{ cursor: 'pointer' }} onClick={this.courseStar.bind(this, course.courseId)}>
                    {course.starred ?
                            <img src={_common.GetDefaultIcons('star_full_icon')}alt="courseStar" />
                            :
                                <img src={_common.GetDefaultIcons('star_icon')}alt="courseStar" />

                    }
                </a>
                <Tooltip data={course.upcomingActivity && course.upcomingActivity > 0 ?
                        T.t('r_activity_deadline_criteria_warning').replace('{0}', course.upcomingActivity!) :
                        T.t('r_no_activity_deadline_criteria_warning')} position='top'>
                <a onClick={this.navigateUrl.bind(this, course.classId, course.courseId)} style={{  cursor: 'pointer' }} className={(course.upcomingActivity && course.upcomingActivity > 0) ? 'notify-dot' : 'opacity-3'}>
                        <img
                            src={_common.GetDefaultIcons('clock_icon')}alt="Clock"
                        />
                </a>
                </Tooltip>
                <Tooltip data={T.t('r_gen_student_newAnnouncement_count').replace('{0}', course.isNotifications!)} position='top'>
                <a  className={(course.isNotifications && course.isNotifications > 0) ? 'notify-dot' : ''}  onClick={this.navigateUrl.bind(this, course.classId, course.courseId)}>
                    {/* <i className={(course.isNotifications && course.isNotifications > 0) ? 'material-icons notify-dot' : 'material-icons'} style={(course.isNotifications && course.isNotifications > 0) ? { color: '#000000' } : { color: '#c9c8c5' }}>
                        forum
                    </i> */}
                    <img
                            src={_common.GetDefaultIcons('forum_icon')}alt="forum"
                        />
                </a>
                </Tooltip>
                <div className="list-icons ml-2">

                    <Tooltip data={this.state.isTeacher ? T.t('r_gen_teacher_progress_info') : T.t('r_course_progress')} position='top'>
                        <ProgressCircle percent={course.progress} />
                    </Tooltip></div>
            </div>
        )
    }

    renderTerms = (course: any) => {
        return (
            <div className="passed_sessions">
                <span className="alms-h5">{course.termName && course.termName.length > 0 ? course.termName : T.t('r_gen_non_term_courses')}</span>
                <div className="course_options" >
                    <div className="list-icons">
                        <div>
                            <i className="material-icons" style={{ fontSize: " xx-large", color: '#c9c8c5' }}>
                            {this.state.prevCourseId == course.courseId ? 'expand_less': 'expand_more'}
                            </i>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderCourseCard = (course: any) => {
        return (
            <li className={course.activeStatus === 0 ? "active_course_list_item archived_lesson" : "active_course_list_item"} style={{marginBottom: "0px"}}>
                <div className="row">
                    <div className="col-md-8 course_info s">
                        <img src={defaultCourse} className={'course-icon'} />
                        {/* <img onError={this.onErrorCourseLogo} className="course-icon" src={_common.GetDefaultImages('course')} /> */}
                        {this.renderCourseInfo(course)}
                    </div>
                    {this.renderCourseOptions(course)}
                </div>
            </li>
        )
    }


    public render() {
        return (
            this.state.termCourses && this.state.termCourses.length > 0 ?
                this.state.termCourses
                    .map((item: any, index: any) =>
                        item
                            .map((course: any, index2: any) =>
                                <li key={course}> <a data-toggle="collapse" href={"#passedClassesList".concat(course.termId)}
                                    style={{ textDecoration: 'none', cursor:'pointer' }} onClick={() => this.expandClicked(course.courseId)}>
                                    {index2 === 0 ? (this.renderTerms(course)) : ''}</a>
                                    <div className="collapse" id={"passedClassesList".concat(course.termId)}>
                                        <ul className="active_course_list" style={{width: "100%", marginBottom: "0px"}}>
                                            {index2 < this.state.elementsCount ?
                                                this.renderCourseCard(course)
                                                : (index2 === this.state.elementsCount && <><button onClick={() => this.onShowMoreBtnClick(item.length)} className="float-right show_more_text" style={{ fontSize: "12px", color: "#908f8d", marginBlockStart: '5px', border:'none', background:'none' }}>{T.t('r_gen_show_more')}</button><br /></>)}
                                        </ul>
                                    </div>
                                </li>
                            )
                    ) :
                ''
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICourseList): ICourseList => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICourseList = Object.assign({}, ownProps, {
        userHomeMyCourses: state.userHomePage.userHomeMyCourses,
        useHomeMyCoursesIsLoading: state.userHomePage.useHomeMyCoursesIsLoading,
        userType: state.login.identitiy.userType,
        searchfilters: state.userHomePage.searchfilters
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        // next.userHomePage.useHomeMyCoursesIsLoading === prev.userHomePage.useHomeMyCoursesIsLoading
        next.userHomePage.userHomeMyCourses === prev.userHomePage.userHomeMyCourses &&
        next.userHomePage.searchfilters === prev.userHomePage.searchfilters
    );
    return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};


const PastSessionsList = connect(
    mapStateToProps,
    dispatchProps,
    null, {
    areStatesEqual
}
)(CPastSessionsList);

export default PastSessionsList;
